import React from "react";
import { TagSetOrEditCustomFieldPage } from "./TagSetOrEditCustomFieldPage";
interface CreateTenantTagSetPageProps {
    spaceId: string;
}
export function CreateTenantTagSetPage({ spaceId }: CreateTenantTagSetPageProps) {
    return <TagSetOrEditCustomFieldPage spaceId={spaceId} create/>;
}
